import { timeParseNoNull } from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**
 * Retrieves exposure data for currencies
 * @param {object} _this: context variables
 */
export function getExpoData(_this) {
  const requestToken = _this.dataLoadToken || 0;
  _this.expo = [];
  _this.expo_deleted = [];
  let getPortfolioNumber = [];
  _this.showLoadingExpo = true;
  try {
    _this.selectedPortfolios.forEach(function(selectedPortfolio) {
      getPortfolioNumber.push(
        _this.companies[_this.selectedCompany].portfolios[selectedPortfolio.id]
          .pk_idportfolio
      );
    });
  } catch (error) {
    _this.showLoadingExpo = false;
    console.log("Portfolio list error", error);
  }
  let getCurrencyNumber = [];
  try {
    for (var crncy in _this.selectedCurrency) {
      getCurrencyNumber.push(
        _this.currencySpecs.filter(
          curr => curr.currency_name === _this.selectedCurrency[crncy].name
        )[0].pk_i_idcurrency
      );
    }
  } catch (error) {
    _this.showLoadingExpo = false;
  }

  let params = {
    method: "GET",
    endpoint: "currency-exposure",
    content_type: "application/json",
    query_params: {
      format: "json",
      currency: { id_currencies: getCurrencyNumber },
      portfolios: { id_portfolios: getPortfolioNumber }
    }
  };
  apiService
    .getAll(params)
    .then(data => {
      if (requestToken !== (_this.dataLoadToken || 0)) return;
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        d.pk =
          _this.companies[_this.selectedCompany].company_name
            .split(/\s/)
            .reduce((response, word) => (response += word.slice(0, 1)), "") +
          d.pk_idcurrencyexposure;
        d.issue_date = timeParseNoNull(d.issue_date);
        d.expiration_date = timeParseNoNull(d.expiration_date);
        d.planned_expiration_date = timeParseNoNull(d.planned_expiration_date);
        d.realized_expiration_date = timeParseNoNull(
          d.realized_expiration_date
        );
        d.hedged_date = timeParseNoNull(d.hedged_date);
        d.sale_date = timeParseNoNull(d.sale_date);
        d.shipping_date = timeParseNoNull(d.shipping_date);
      });
      _this.expo = data;
      _this.showLoadingExpo = false;
      _this.dataSavedExpo = true;
      _this.saveLegendExpo = "Saved:";
      _this.refreshLegendExpo = "Synced:";
    })
    .catch(function(error) {
      if (requestToken !== (_this.dataLoadToken || 0)) return;
      _this.showLoadingExpo = false;
      _this.dataSavedExpo = true;
      _this.saveLegendExpo = "Saved:";
      _this.refreshLegendExpo = "Synced:";
      console.log(error);
    });
}
